import e from"@emotion/styled";import{setFontSize as t,setColor as r}from"../../utils/generateStyles.js";import{retrieveContentStyles as i}from"./Badge.utils.js";const n=e.span`
  label: badge;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1 / 1;
  border-radius: 9999px;
  ${o=>i(o.children)}
  ${o=>o.hasBorder&&{minWidth:"8px",minHeight:"8px",borderWidth:"1.16667px",borderStyle:"solid",borderColor:"rgb(248 249 250 / 1);"}};
  ${o=>t(o.fontSize)}
  ${o=>r(o.color,"color")}
  ${o=>r(o.backgroundColor,"backgroundColor")}
`;export{n as default};
